module.exports = __webpack_public_path__ + "static/media/92 - UTO - The Beast.bb956204.mp3";